import { WfSvgProps } from '../wf-svg';

import './index.scss';

interface WfPageTipProps {
  SvgComponent?: React.FC<WfSvgProps>;
  title: string;
  BtnSvgComponent?: React.FC<WfSvgProps>;
  btnText?: string;
  showMessageAtBottom?: boolean;
  onClickBtn?: () => void;
}

function WfPageTip(props: WfPageTipProps) {
  const { SvgComponent, title, BtnSvgComponent, btnText, showMessageAtBottom, onClickBtn } = props;

  return (
    <div className="wf-page-tip-container" style={showMessageAtBottom ? { top: 'auto', bottom: '20px' } : undefined}>
      {SvgComponent && <SvgComponent className="wf-page-tip-svg" />}

      <p className="wf-page-tip-title">{title}</p>

      {!!onClickBtn && (
        <button className="wf-page-tip-button" onClick={onClickBtn}>
          {BtnSvgComponent && <BtnSvgComponent className="wf-page-tip-button-icon" />}
          {btnText}
        </button>
      )}
    </div>
  );
}

export default WfPageTip;
